<template>
	<div class="lime-body">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb breadcrumb-separator-1">
                                <li class="breadcrumb-item"><a href="#">Payment</a></li>
                                <li class="breadcrumb-item active" aria-current="page">000001</li>
                            </ol>
                        </nav>
                        <div class="page-title">
                            <h3>Invoices</h3>
                            <div class="search-create">
                                <router-link to="/payment" class="btn btn-primary">
                                    <i class="material-icons">arrow_back</i>
                                    Back to Payment List
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card invoice-detail">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Billed To :</label>
                                            <span class="value">Adidas</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Name :</label>
                                            <span class="value">No Name</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Address :</label>
                                            <span class="value">No Name</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Phone Number :</label>
                                            <span class="value">No Phone Number</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Currency :</label>
                                            <span class="value">CAD - Canadian Dollar</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Invoice No :</label>
                                            <span class="value">000001</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Billing Method :</label>
                                            <span class="value">Send Invoice</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">Ghost Profit :</label>
                                            <span class="value">34%</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">User A Profit :</label>
                                            <span class="value">33%</span>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label">User B Profit :</label>
                                            <span class="value">33%</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Description</th>
                                                <th scope="col">Qty</th>
                                                <th scope="col">Unit Price</th>
                                                <th scope="col">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</td>
                                                <td>1</td>
                                                <td>CA$ 1,000.00</td>
                                                <td>CA$ 1,000.00</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td>Sub Total</td>
                                                <td>CA$ 1,000.00</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td>Total</td>
                                                <td>CA$ 1,000.00</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td>Due Amount</td>
                                                <td>CA$ 1,000.00</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>      
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>
<script>
  export default {
    name: 'paymentDetail'
  }
</script>



// WEBPACK FOOTER //
// src/components/paymentDetail.vue